import { create } from 'zustand';

export interface Toast {
  id: number;
  text: string;
  tone: 'ok' | 'bad';
}

interface ToastState {
  items: Toast[];
  show: (text: string, tone?: Toast['tone']) => void;
  dismiss: (id: number) => void;
}

let seq = 0;

export const useToast = create<ToastState>((set, get) => ({
  items: [],
  show(text, tone = 'ok') {
    const id = ++seq;
    set({ items: [...get().items.slice(-2), { id, text, tone }] });
    setTimeout(() => get().dismiss(id), 4000);
  },
  dismiss(id) {
    set({ items: get().items.filter((x) => x.id !== id) });
  },
}));

export const toast = (text: string, tone?: Toast['tone']) => useToast.getState().show(text, tone);
